"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEditorialLandingPage = void 0;
var _fetching = require("@ori/fetching");
var _queriesNet = require("../queries-net");
var _utils = require("../utils");
/**
 * Fetch function that fetches data for editorial landing page from GraphQL.
 */ const getEditorialLandingPage = async (param)=>{
    let { graphQlUrl, headers, pageId } = param;
    const data = await (0, _fetching.fetchGraphql)({
        query: _queriesNet.editorialLandingPageQuery,
        url: graphQlUrl,
        variables: {
            pageId
        },
        headers
    });
    var _data_application;
    const { editorialLandingPage } = (_data_application = data.application) !== null && _data_application !== void 0 ? _data_application : {};
    return {
        application: {
            editorialLandingPage: editorialLandingPage ? {
                ...editorialLandingPage,
                themeItems: (0, _utils.filterOutCurrentCategory)({
                    pageId,
                    categories: editorialLandingPage.themeItems
                })
            } : undefined
        }
    };
};
exports.getEditorialLandingPage = getEditorialLandingPage;
